import { useSelector } from 'react-redux';
import profileStore from '@benniehealth/core-js/store/profile';
import { getHasActiveEnrollments } from '@app/store/profile/selectors';

const useTourState = () => {
  const hasActiveEnrollments = useSelector(getHasActiveEnrollments);
  const needsTourFromProfile = useSelector(profileStore.selectors.getNeedsTour);

  const canShowTour = hasActiveEnrollments;
  const shouldRunAppIntroTour = canShowTour && needsTourFromProfile;

  return { canShowTour, shouldRunAppIntroTour };
};

export default useTourState;
